import request from '@/utils/request'
const BASE_URL = '/wx/malls'

export default {
  codelogin(code) {
    return request({
      url: BASE_URL + '/codelogin',
      method: 'post',
      data: { code: code }
    })
  },
  getLoginUser(token = null) {
    if (token) request.defaults.headers['Authorization'] = "Bearer " + token;
    return request({
      url: BASE_URL + '/user',
      method: 'get',
    })
  },
  saveSort(data) {
    return request({
      url: BASE_URL + '/savesort',
      method: 'post',
      data
    })
  },
  saveUser(data) {
    return request({
      url: BASE_URL + '/saveuser',
      method: 'post',
      data
    })
  },
}